document.addEventListener('DOMContentLoaded', () => {

  const sidebarItems = document.querySelectorAll('.nde-sidebar-item');

  sidebarItems.forEach((item) => {

    item.addEventListener('toggle', () => {

      if (item.open) {

        sidebarItems.forEach((otherItem) => {

          if (otherItem !== item) {
            otherItem.removeAttribute('open');
          }

        });

      }

    });

  });

});